import { render, staticRenderFns } from "./BrebVideo.vue?vue&type=template&id=0f817443&scoped=true&"
import script from "./BrebVideo.vue?vue&type=script&lang=js&"
export * from "./BrebVideo.vue?vue&type=script&lang=js&"
import style0 from "./BrebVideo.vue?vue&type=style&index=0&id=0f817443&prod&lang=less&scoped=true&"
import style1 from "./BrebVideo.vue?vue&type=style&index=1&id=0f817443&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f817443",
  null
  
)

export default component.exports